import { render, staticRenderFns } from "./DeviceInfoCard.vue?vue&type=template&id=d612f1f8&scoped=true"
import script from "./DeviceInfoCard.vue?vue&type=script&lang=ts"
export * from "./DeviceInfoCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d612f1f8",
  null
  
)

export default component.exports